import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPaginar } from '@core/interfaces/paginacion/paginacion.interface';
import {
  IReporteKardexFiltroReq,
  IReporteKardexRes,
} from '@core/interfaces/request-response/kardex.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class KardexApiService extends BaseHttpService {
  paginarReporte(rq: IReporteKardexFiltroReq, pagina: number, size: number) {
    const params = new HttpParams().set('pagina', pagina.toString()).set('size', size.toString());
    return this.withLoader(
      this.httpClient.post<IPaginar<IReporteKardexRes>>(
        `${environment.apiUrl}${environment.apiPreFix}/kardex/v2/paginar-reporte`,
        rq,
        { params },
      ),
    );
  }

  exportarReporteExcel(rq: IReporteKardexFiltroReq) {
    return this.withLoader(
      this.httpClient.post(
        `${environment.apiUrl}${environment.apiPreFix}/kardex/v2/exportar-reporte-excel`,
        rq,
        {
          observe: 'response',
          responseType: 'blob',
        },
      ),
    );
  }
}
